import { isEmail, isLength } from "validator";
import messages from "../common/messages";

export function validateInternalCrmForm({  agentid,
    crmname,
    environment,
     baseurl,
    authtokendpoint,
    clientid,    
    clientsecretkey,
    otherinformation ,updateStatusTime,update_time_status}) {
    let errors = {};
    if (!agentid) {
        errors.agentid = messages["agentid.required"];
    } 
 
      if (!crmname) {
        errors.crmname = messages["crmname.required"];
    }
    if (!environment) {
        errors.environment = messages["environment.required"];
    }
    if (!baseurl) {
        errors.baseurl = messages["baseurl.required"];
    }
    if (!authtokendpoint) {
        errors.authtokendpoint = messages["authtokendpoint.required"];
    }
    if (!clientid) {
        errors.clientid = messages["clientid.required"];
    }
    if (!clientsecretkey) {
        errors.clientsecretkey = messages["clientsecretkey.required"];
    }
    // if (!otherinformation) {
    //     errors.otherinformation = messages["otherinformation.required"];
    // }
    if (!updateStatusTime) {
        errors.updateStatusTime = messages["updateStatusTime.required"];
    }
    if (!update_time_status) {
        errors.update_time_status = messages["update_time_status.required"];
    }
    return errors; 
}

export function validateAPITestForm({  
    crmname,
    authtokendpoint,
    clientid,    
    clientsecretkey }) {
    let errors = {};
    if (!crmname) {
        errors.crmname = messages["crmname.required"];
    }
    if (!authtokendpoint) {
        errors.authtokendpoint = messages["authtokendpoint.required"];
    }
    if (!clientid) {
        errors.clientid = messages["clientid.required"];
    }
    if (!clientsecretkey) {
        errors.clientsecretkey = messages["clientsecretkey.required"];
    }   
    return errors; 
}